import styled, { css } from "styled-components";

export interface IJackpotWidgetAspectRatioBoxProps {
    forcePCView?: boolean;
    shouldMinimize?: boolean;
};

export const JackpotWidgetAspectRatioBox = styled.div<IJackpotWidgetAspectRatioBoxProps>`
    position: relative;
    padding-top: ${({shouldMinimize}) => shouldMinimize ? "25%" : "58%"};
    transition: padding-top 0.5s ease-in-out;

    ${({forcePCView}) => !forcePCView && css`
        @media ${({theme}) => theme.mediaQuery.sAndBelow} {
            padding-top: 123%;
        }
    `}

`;
